import React from 'react';
import CommonModal from './CommonModal';

function ApprovalFormSelectModal({ show, onClose, formsTree, onSelectForm }) {
  if (!show) return null;

  const renderTree = (nodes) => (
    <ul className="list-group list-group-flush ms-3">
      {nodes.map((node) => (
        <li key={node.form_code} className="custom-list-item">
          <div className="d-flex justify-content-between align-items-center">
            <span>
              {node.form_type === 'form' ? '📄' : '📂'} {node.form_name}
            </span>
            {node.form_type === 'form' && (
              <button
                className="btn btn-sm btn-outline-primary ms-2"
                onClick={() => onSelectForm(node.form_code)}
              >
                선택
              </button>
            )}
          </div>
          {node.children && node.children.length > 0 && renderTree(node.children)}
        </li>
      ))}
    </ul>
  );

  return (
    <CommonModal title="📑 결재양식 선택" onClose={onClose} size="lg">
      {formsTree.length === 0 ? (
        <p className="text-muted">등록된 결재양식이 없습니다.</p>
      ) : (
        renderTree(formsTree)
      )}
    </CommonModal>
  );
}

export default ApprovalFormSelectModal;